/** Parse `yyyy-MM-dd` or `yyyy-MM-ddTHH:mm[:ss]` as local wall-clock (no timezone suffix). */
export function parseWallClockInstant(iso: string): Date {
  const normalized = iso.replace(/\.\d{3}Z?$/, '').replace(/Z$/, '');
  const [datePart, timePart] = normalized.split('T');
  const [year, month, day] = datePart.split('-').map(Number);
  if (timePart) {
    const [hourStr, minuteStr, secondStr] = timePart.split(':');
    const seconds = secondStr ? Number(secondStr.split('.')[0]) : 0;
    return new Date(year, month - 1, day, Number(hourStr), Number(minuteStr), seconds, 0);
  }
  return new Date(year, month - 1, day);
}

/** Format a Date as local wall-clock `yyyy-MM-ddTHH:mm` or `yyyy-MM-ddTHH:mm:ss`. */
export function formatWallClockInstant(
  date: Date,
  precision: 'minutes' | 'seconds' = 'minutes',
): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  const base = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  if (precision === 'seconds') {
    return `${base}:${pad(date.getSeconds())}`;
  }
  return base;
}

/** Local calendar date key `yyyy-MM-dd` (not UTC). */
export function formatLocalDateKey(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
